
<template>
    
        <mars-view class="prompt c-font-small" :class="fixBottom ? 'l-fix-bottom' : ''" :style="{
        backgroundColor: noColor ? '' : '#f5f5f5',
        fontSize: fontSize + 'px',
    }"><mars-view v-for="(tip, index) in data" :key="index" :class="{'rich-inline': tip.isInLine === '1'}" class="c-color-gray" @click.native="tapFn(tip)"><mars-rich-text v-if="tip.type === 'm-call' || tip.type === 'm-webview' || tip.type === 'url' || tip.type === 'webview'" :nodes="txtArr[index]" class="rich"></mars-rich-text><mars-image v-else-if="tip.type === 'img' && tip.isInLine === '0'" :lazy-load="true" class="prompt-img" :class="{'prompt-img-inline': tip.isInLine === '1'}" src="https://lvlin-base.cdn.bcebos.com/law/pages/home/lvlin-logo-new.png"></mars-image><mars-view v-else-if="tip.type === 'img' && tip.isInLine === '1'" class="prompt-img-inline"><mars-view class="icon iconfont prompt-img-inline-icon"></mars-view><mars-view class="prompt-img-inline-line"></mars-view></mars-view><mars-text v-else class="c-color-gray">
            {{ txtArr[index] }}
        </mars-text></mars-view><mars-view v-if="isShowJoinEntrance" class="help-box"><join-entrance :fr="fr"></join-entrance></mars-view></mars-view>
    
</template>

<script>
import { act } from '../../static/utils/navigate.js';
import joinEntrance from "./joinEntrance.vue";
export default {
  components: {
    joinEntrance
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    noColor: {
      type: Boolean,
      default: false
    },
    fixBottom: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: String,
      default: '12'
    },
    isShowJoinEntrance: {
      type: Boolean,
      default: false
    },
    fr: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      txtArr: []
    };
  },
  mounted() {
    this.mapData();
  },
  methods: {
    tapFn({
      target,
      type
    }, log) {
      if (!target) {
        return;
      }
      this.$emit('sendlog', {
        target,
        type,
        log
      });
      act({
        target,
        type,
        log
      });
    },
    mapData() {
      this.data && this.data.forEach(item => {
        this.txtArr.push(item.txt.replace('<a>', '<a class="c-color-gray">'));
      });
    }
  },
  watch: {
    data() {
      this.mapData();
    }
  }
};
</script>

<style scoped>
.rich-inline {
  display: inline-block;
}
.prompt-img {
  width: 0.65rem;
  height: 0.21rem;
  margin-bottom: 0.06rem;
}
.prompt-img-inline {
  display: inline-flex;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
}
.prompt-img-inline-icon {
  display: inline;
  font-size: 14px;
  margin-top: 3px;
}
.prompt-img-inline-line {
  display: inline-block;
  width: 1px;
  background: #ccc;
  height: 14px;
  margin: 0px 3px 0 8px;
  vertical-align: middle;
  margin-top: 3px;
}
.rich {
  display: inline-block;
}
.prompt {
  padding: 20px 17px 20px;
  text-align: center;
}
.c-color-black {
  color: #999;
}
.c-color-blue {
  color: #445fbb;
}
 /deep/ .c-color-blue {
  color: #445fbb;
}
.help-box {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #666;
  text-align: center;
  line-height: 1;
  margin-top: 0.12rem;
}
.c-color-gray {
  color: #50525c;
  font-size: 0.14rem;
}

</style>
